import { SxProps, Theme } from '@mui/material/styles';
import { SelectOption } from 'basics/options/options.types';
import { YodaFieldValidation, YodaFieldValue } from 'yoda-ui/yodaForm/yodaForm.types';

export enum SortType {
  Alphabetical = 'alphabetical',
  Length = 'length',
  None = 'none',
}

export type SelectYodaInputProps = {
  label: string;
  name: string;
  options: SelectOption[];
  value?: SelectOption;
  freeOption?: boolean;
  freeDefaultValue?: string;
  defaultValue?: YodaFieldValue;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: Function;
  disableClearable?: boolean;
  validation?: YodaFieldValidation;
  maxHeight?: number;
  overflow?: string;
  loading?: boolean;
  loadingText?: string;
  clearOption?: boolean;
  disableAutoComplete?: boolean;
  sortType?: SortType;
  forcePopupIcon?: boolean;
  iconColor?: string | null;
  filterEnabled?: boolean;
  onFilterEnabledChange?: (enabled: boolean) => void;
  showFilter?: boolean;
  filterLabel?: string;
  paperSx?: SxProps<Theme>;
};
